import { auth } from '../firebase/config';

const MAILING_API_URL = (import.meta.env.VITE_API_BASE_URL || '') + '/api/mailing';

const getAuthToken = async () => {
    const user = auth.currentUser;
    if (!user) throw new Error('Usuario no autenticado');
    return await user.getIdToken();
};

const fetchWithAuth = async (url, options = {}) => {
    const token = await getAuthToken();
    const headers = {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json',
        ...options.headers
    };
    const response = await fetch(`${MAILING_API_URL}${url}`, { ...options, headers });
    if (!response.ok) {
        const error = await response.json();
        throw new Error(error.message || 'Error en la petición');
    }
    return response.json();
};

// Campaigns
export const getCampaigns = () => fetchWithAuth('');
export const createCampaign = (data) => fetchWithAuth('', { method: 'POST', body: JSON.stringify(data) });
export const updateCampaign = (id, data) => fetchWithAuth(`/${id}`, { method: 'PUT', body: JSON.stringify(data) });
export const deleteCampaign = (id) => fetchWithAuth(`/${id}`, { method: 'DELETE' });
export const sendCampaign = (id) => fetchWithAuth(`/${id}/send`, { method: 'POST' });
export const getRecipients = (id) => fetchWithAuth(`/${id}/recipients`);
// Public unsubscribe (no auth required)
export const publicUnsubscribe = (payload) => fetch(`${MAILING_API_URL}/unsubscribe`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload)
}).then(async res => {
    if (!res.ok) {
        const err = await res.json();
        throw new Error(err.message || 'Error');
    }
    return res.json();
});
